import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ChecklistIcon from '@mui/icons-material/Checklist';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EditIcon from '@mui/icons-material/Edit';
import GppBadIcon from '@mui/icons-material/GppBad';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import VerifiedIcon from '@mui/icons-material/Verified';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

/**
 * Returns an action that can be taken when navigating through stepper form
 */
export const NAVIGATION_ACTIONS = {
	CANCEL: 'cancel',
	HOME: 'home',
	NEXT: 'next',
	PREVIOUS: 'previous',
	RESTART: 'restart',
	SUBMIT: 'submit',
	GOTO: 'goto',
};

/**
 * Returns MUI Icons representing each UAR page
 */
export const PAGE_ICONS = {
	EDIT: EditIcon,
	HOME: DashboardIcon,
	RENEW: VerifiedUserIcon,
	REVIEW: VerifiedIcon,
	DELEGATE: AdminPanelSettingsIcon,
	REASSIGN: TransferWithinAStationIcon,
	SUMMARY: ChecklistIcon,
	TERMINATE: GppBadIcon,
};

/**
 * Returns a page identifier for each UAR page
 */
export const PAGE_IDS = {
	EDIT: 'UAR_EDIT',
	HOME: 'UAR_HOME',
	RENEW: 'UAR_RENEW',
	REVIEW: 'UAR_REVIEW',
	DELEGATE: 'UAR_DELEGATE',
	REASSIGN: 'UAR_REASSIGN',
	SUMMARY: 'UAR_SUMMARY',
	TERMINATE: 'UAR_TERMINATE',
};

/**
 * Returns the route path for each UAR page
 */
export const PAGE_ROUTES = {
	EDIT: '/UserAccessReview/Edit',
	HOME: '/UserAccessReview/Home',
	RENEW: '/UserAccessReview/Renew',
	REVIEW: '/UserAccessReview/Review',
	REVIEW_ACTION_FLOW: '/UserAccessReview/Review/ActionFlow',
	REVIEW_PROCESSED_REQUESTS: '/UserAccessReview/Review/ProcessedRequests',
	DELEGATE: '/UserAccessReview/Delegate',
	REASSIGN: '/UserAccessReview/Reassign',
	SUMMARY: '/UserAccessReview/Summary',
	TERMINATE: '/UserAccessReview/Terminate',
};

/**
 * Returns a string to be used to create Block-Element-Modifier-style IDs for styles and clickable elements
 */
export const BEM_NAME_ELEMENTS = {
	VIEW_BREADCRUMBS: 'navigation-breadcrumbs',
	VIEW_NAVIGATION: 'navigation',
	VIEW_EDIT: 'edit-profile',
	VIEW_DELEGATE: 'delegate',
	VIEW_REASSIGN: 'reassign',
	VIEW_RENEW: 'renew',
	VIEW_REVIEW: 'review',
	VIEW_SUMMARY: 'summary',
	VIEW_TERMINATE: 'terminate',
	FIELD_ACCORDION: 'accordion',
	FIELD_BUTTON: 'button',
	FIELD_CHECKBOX: 'checkbox',
	FIELD_LINK: 'link',
	FIELD_LIST: 'list',
	FIELD_SELECT: 'select',
	FIELD_SPEED_DIAL: 'speed-dial',
	FIELD_SWITCH: 'switch',
	FIELD_TEXT_FIELD: 'textfield',
	SUBMIT: 'submit',
};

export const UAR_CONSTANTS = {
	PAGE_DASHBOARD: 'PAGE_DASHBOARD',
	PAGE_ACCOUNT_DETAILS: 'PAGE_ACCOUNT_DETAILS',
	PAGE_DELEGATE: 'PAGE_DELEGATE',
	PAGE_ORG_CHART: 'PAGE_ORG_CHART',
	PAGE_REASSIGN: 'PAGE_REASSIGN',
	PAGE_RENEW: 'PAGE_RENEW',
	PAGE_TERMINATE: 'PAGE_TERMINATE',
	PAGE_UPDATE_PROFILE: 'PAGE_UPDATE_PROFILE',
	PAGE_REVIEW_EMPLOYEE_ACCESS: 'PAGE_REVIEW_EMPLOYEE_ACCESS',
	PAGE_VALIDATE: 'PAGE_VALIDATE',
	PAGE_DASHBOARD_ACTION: 'View Dashboard',
	PAGE_ACCOUNT_DETAILS_ACTION: 'View Account Details',
	PAGE_DELEGATE_ACTION: 'Delegate Account(s)',
	PAGE_ORG_CHART_ACTION: 'View Org Chart',
	PAGE_REASSIGN_ACTION: 'Reassign Account(s)',
	PAGE_TERMINATE_ACTION: 'Terminate Account(s)',
	PAGE_UPDATE_PROFILE_ACTION: 'Update Account Details',
	PAGE_VALIDATE_ACTION: 'Validate Account(s)',
	NON_EMPLOYEE: 'Non-Employee',
	NON_EMPLOYEE_KEY: 'nonEmployee',
	EMPLOYEE: 'Employee',
	EMPLOYEE_KEY: 'employee',
	CONTINGENT_WORKER: 'Contingent Worker',
	CONTINGENT_WORKER_KEY: 'contingentWorker',
	SERVICE_ACCOUNT: 'Service Account',
	SERVICE_ACCOUNT_KEY: 'serviceAccount',
	APPLICATION_MODIFY: 'MODIFY',
	APPLICATION_REVOKE: 'REVOKE',
};

export const SUBMISSION_LOADING_TITLE = 'Please wait while your form submits.';
export const SUBMISSION_LOADING_BULK_MESSAGE =
	'Submitting for more than one account may take more time to process.';

/**
 * Validation Status Types
 */
export const STATUS_TYPES = {
	OVERDUE: 'OVERDUE',
	VALID_EXPIRING_SOON: 'VALID_EXPIRING_SOON',
	VALID: 'VALID',
};
